<template>
  <div aria-labelledby="comment-title" role="region">
    <h2 id="comment-title" class="sr-only">
      {{ $t('field.comment') }}
    </h2>
    <TextArea
      :label="$t('field.comment')"
      v-model="comment"
      :error="errorMessage"
      :required="false"
      id="comment-textarea"
      :max-length="maxLength"
      :icon="icon"
      :iconColor="iconColor"
    />
    <Button
      secondary
      icon-left="floppy-disk"
      @click="onCommentSelected"
      :aria-label="$t('comment.ariaLabel.save')"
      :aria-describedby="errorMessage ? 'comment-error' : null"
      :disabled="!!errorMessage"
    >
      <span>{{ $t('comment.button.save') }}</span>
    </Button>
  </div>
</template>

<script>
import Button from "@/components/actions/Button.vue";
import TextArea from "@/components/forms/TextArea.vue";

export default {
  components: {
    TextArea,
    Button,
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 500
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      comment: this.value,
      errorMessage: null,
    };
  },
  watch: {
    value(newVal) {
      this.comment = newVal;
    }
  },
  methods: {
    onCommentSelected() {
      if (!this.comment) {
        this.errorMessage = this.$t('comment.messages.error.required');
        return;
      }
      this.errorMessage = null;
      this.$emit('input', this.comment); // keep v-model in sync
      this.$emit('comment-selected', this.comment);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
